import React, { useRef, useState, useEffect } from 'react'
import './DataManagementMenu.css'
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Nav } from 'reactstrap'

const DataManagementMenu = () => {
  const [open, setOpen] = useState(false)
  const dropdownRef = useRef<any | null>(null)

  // const handleClickOutside = (event) => {
  //   if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //     setOpen(false);
  //   }
  // };

  // useEffect(() => {
  //   if (open) {
  //     document.addEventListener('mousedown', handleClickOutside);
  //   } else {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   }

  //   // Cleanup function to remove event listener
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, [open]);

  const handleClick = () => {
    setOpen(true);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div onClick={() => handleClick()} className={`dropdown ${open ? 'open' : ''}`} ref={dropdownRef}role='menu'>
      <div className='data-mgmt-toggle'>
        <span className='glyphicons glyphicons-cloud-download'>
          Data Management
          <span className='dropdown-toggle' style={{ transform: 'rotate(-90deg)', display: 'inline-block'  }}>
            
          </span>
     </span>
        {/* <span className='glyphicons glyphicons-chevron-right arrow' /> */}
      </div>
      <ul className={`dropdown-menu ${open ? 'show' : ''}`}>
        <li>
          <a
            className='menuItem dropdown-item glyphicons glyphicons-stats '
            href='/ui/#!/server/dataManagement/trending'
          >
              Trending
          </a>
        </li>
        <li>
          <a
            className='dropdown-item glyphicons glyphicons-refresh menuItem'
            href='/ui/#!/server/dataManagement/recycleBin'
          >
              Recycle Bin
          </a>
        </li>
        <li>
          <a className='dropdown-item menuItem glyphicons glyphicons-dashboard' href='/ui/#!/server/dataManagement/usage'>
              Usage
          </a>
        </li>
      </ul>
    </div>
  )
}

export default DataManagementMenu